const UrlName = '/course/v1/open'
export default API => ({
    // 获取目录
    findCourseItemByCourseId({data, params}) {
        return API({ url: `${UrlName}/courseItem/getValidCourseItemInfo`, params, data });
    },
    // 获取课程详情
    findCourseInfo({data, params}) {
        return API({ url: `${UrlName}/course/findCourseInfo`, params, data });
    },
    // 最近学习
    getRecentPlayCourse({data, params}) {
        return API({ url: `${UrlName}/course/getRecentPlayCourse`, params, data });
    },
    // 观看课程信息保存
    postCourseLearningLogSaveLog({data, params}) {
        return API({ url: `${UrlName}/courseLearningLog/saveLog`, method:'post', params, data });
    },
    // 记录当前用户的学习时长
    postUserLearningLog({data, params}) {
        return API({ url: `/bi/v1/statistics/timingNotify`, method:'post', params, data });
    },
    // 课程评价查询
    getEvaluationInfo({data, params}) {
        return API({ url: `${UrlName}/courseEvaluation/getEvaluationInfo`, params, data });
    },
    //课程评价
    evaluateCourse({data, params}) {
        return API({ url: `${UrlName}/courseEvaluation/evaluateCourse`, method:'post', params, data });
    },
    /**
     * 获取任务里下一个课程
     */
     getNextCourseInfo({data, params}) {
        return API({ url: `/task/v1/client/getNextCourseInfo`, params, data });
    },
})
